export default __webpack_public_path__ + "static/media/screen5.dd321e11.gif";